// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lca .nav-link {
    display: block;
    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
    font-size: var(--bs-nav-link-font-size);
    font-weight: var(--bs-nav-link-font-weight);
    color: var(--bs-nav-link-color);
    text-decoration: none;
    background: 0 0;
    border: 0;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;
}

.lca .nav-line-tabs .nav-item .nav-link {
    font-size: 0.85rem;
    font-weight: 700;
    padding: 0px;
    margin-left: 1rem !important;
    margin-right: 1rem !important;
    color: black;
    text-transform: uppercase;
}

.lca .nav-line-tabs .nav-item .nav-link.active,
.lca .nav-line-tabs .nav-item .nav-link:hover:not(.disabled),
.lca .nav-line-tabs .nav-item.show .nav-link {
    background-color: transparent;
    border: 0;
    padding-bottom: 10px;
    border-bottom: 3px solid var(--bs-primary);
    transition: color .2s ease;
    cursor: pointer;
}

.lca .nav,
.lca .nav>.nav-item>button {
    border: 0px !important;
}

.lca .nav>.nav-item {
    padding-bottom: 6px;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 15px;

}

.lca .nav>.nav-item:has(> .active) {
    background-color: white;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
}

.lca .nav>.nav-item>button {
    font-size: 1rem;
    font-weight: 700;
    text-transform: uppercase;
    padding: 0px;
    color: #747474;
}

.lca .nav>.nav-item>button.active {
    border-bottom: 3px solid var(--bs-primary) !important;
    margin-bottom: 10px;
    padding-bottom: 8px;
}

.lca .tab-pane:first-child .card:not(.results) {
    border-top-left-radius: 0px;
}

.lca .vertical-tabs>ul {
    width: 60px !important;
    float: left !important;
}

.lca .vertical-tabs>ul li {
    border-top: solid 1px #ddd;
    border-left: solid 1px #fafafa;
    padding-left: 0px !important;
    padding-right: 0px !important;
    width: 60px;
    text-align: center;
    position: relative;
    padding-top: 10px !important;
    padding-bottom: 20px !important;
    border-radius: 0px !important;
    background-color: #fafafa;
}

.lca .vertical-tabs>ul li:has(> .active) {
    padding-bottom: 10px !important;

}

.lca .vertical-tabs>ul li:last-child {
    border-bottom: solid 1px #ddd;
}

.lca .vertical-tabs>.tab-content {
    float: left;
    border-left: solid 1px #ddd;
    padding-left: 20px;
    width: calc(100% - 60px);
}

.lca .vertical-tabs>ul li button {
    font-size: 20px !important;
    margin-left: auto;
    margin-right: auto;
    vertical-align: middle;
}

.lca .w-50px {
    width: 50px !important;
    max-width: 50px !important;
}

.lca .totals {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    font-size: 24px;
    text-align: 'left';
    line-height: '20px';
}

.lca .hotspot_analysis canvas {
    width: 100%;
    height: auto;
}

.lca .table tr {
    cursor: pointer !important;
}

.lca .table tr.active td {
    background-color: #3894ad !important;
    color: white !important;
}

.lca .table tr.active td span {
    color: white;
}

.lca .title2 {
    text-align: center;
    margin-bottom: 20px;
    text-transform: uppercase;
    font-weight: bold;
    text-decoration: underline;
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/pages/LCA/lca.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kEAAkE;IAClE,uCAAuC;IACvC,2CAA2C;IAC3C,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,SAAS;IACT,oGAAoG;AACxG;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,6BAA6B;IAC7B,SAAS;IACT,oBAAoB;IACpB,0CAA0C;IAC1C,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;;AAErB;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qDAAqD;IACrD,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,4BAA4B;IAC5B,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;;AAEnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,OAAO;IACP,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;AACnB","sourcesContent":[".lca .nav-link {\n    display: block;\n    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n    font-size: var(--bs-nav-link-font-size);\n    font-weight: var(--bs-nav-link-font-weight);\n    color: var(--bs-nav-link-color);\n    text-decoration: none;\n    background: 0 0;\n    border: 0;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\n}\n\n.lca .nav-line-tabs .nav-item .nav-link {\n    font-size: 0.85rem;\n    font-weight: 700;\n    padding: 0px;\n    margin-left: 1rem !important;\n    margin-right: 1rem !important;\n    color: black;\n    text-transform: uppercase;\n}\n\n.lca .nav-line-tabs .nav-item .nav-link.active,\n.lca .nav-line-tabs .nav-item .nav-link:hover:not(.disabled),\n.lca .nav-line-tabs .nav-item.show .nav-link {\n    background-color: transparent;\n    border: 0;\n    padding-bottom: 10px;\n    border-bottom: 3px solid var(--bs-primary);\n    transition: color .2s ease;\n    cursor: pointer;\n}\n\n.lca .nav,\n.lca .nav>.nav-item>button {\n    border: 0px !important;\n}\n\n.lca .nav>.nav-item {\n    padding-bottom: 6px;\n    padding-left: 30px;\n    padding-right: 30px;\n    padding-top: 15px;\n\n}\n\n.lca .nav>.nav-item:has(> .active) {\n    background-color: white;\n    border-top-right-radius: 5px;\n    border-top-left-radius: 5px;\n}\n\n.lca .nav>.nav-item>button {\n    font-size: 1rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    padding: 0px;\n    color: #747474;\n}\n\n.lca .nav>.nav-item>button.active {\n    border-bottom: 3px solid var(--bs-primary) !important;\n    margin-bottom: 10px;\n    padding-bottom: 8px;\n}\n\n.lca .tab-pane:first-child .card:not(.results) {\n    border-top-left-radius: 0px;\n}\n\n.lca .vertical-tabs>ul {\n    width: 60px !important;\n    float: left !important;\n}\n\n.lca .vertical-tabs>ul li {\n    border-top: solid 1px #ddd;\n    border-left: solid 1px #fafafa;\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n    width: 60px;\n    text-align: center;\n    position: relative;\n    padding-top: 10px !important;\n    padding-bottom: 20px !important;\n    border-radius: 0px !important;\n    background-color: #fafafa;\n}\n\n.lca .vertical-tabs>ul li:has(> .active) {\n    padding-bottom: 10px !important;\n\n}\n\n.lca .vertical-tabs>ul li:last-child {\n    border-bottom: solid 1px #ddd;\n}\n\n.lca .vertical-tabs>.tab-content {\n    float: left;\n    border-left: solid 1px #ddd;\n    padding-left: 20px;\n    width: calc(100% - 60px);\n}\n\n.lca .vertical-tabs>ul li button {\n    font-size: 20px !important;\n    margin-left: auto;\n    margin-right: auto;\n    vertical-align: middle;\n}\n\n.lca .w-50px {\n    width: 50px !important;\n    max-width: 50px !important;\n}\n\n.lca .totals {\n    position: absolute;\n    width: 100%;\n    top: 50%;\n    left: 0;\n    font-size: 24px;\n    text-align: 'left';\n    line-height: '20px';\n}\n\n.lca .hotspot_analysis canvas {\n    width: 100%;\n    height: auto;\n}\n\n.lca .table tr {\n    cursor: pointer !important;\n}\n\n.lca .table tr.active td {\n    background-color: #3894ad !important;\n    color: white !important;\n}\n\n.lca .table tr.active td span {\n    color: white;\n}\n\n.lca .title2 {\n    text-align: center;\n    margin-bottom: 20px;\n    text-transform: uppercase;\n    font-weight: bold;\n    text-decoration: underline;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
